
<!--  <div class="gc-user-avatar">
    <div class="gc-user-img">
      <img src="{{ profilePic ? profilePic : defaultUserPicture}}">
    </div>
    <div class="gc-user-info">
      <h3>{{firstName}} {{lastName}}</h3>
      <p>{{ userRole }}</p>
    </div>
  </div>-->
  <div class="navigations">
    <ul *ngFor="let item of items$ ">
      <li>
        <a routerLink="{{ item.routeOrFunction}}" routerLinkActive="active" [pTooltip]="item.tooltip || ''" tooltipPosition="right">
          <span class="{{ item.customClass}}"><img src="../../../assets/images/{{ item.icon}}.svg" alt="{{ item.name}}"></span>
          <span class="gc-nav-text">{{ item.name}}</span>
          <span class="gc-nav-collapse">{{ item.name}}</span>
        </a>
      </li>
    </ul>
  </div>


  <div class="gc-logout-btn"><a  (click)="logOut()" class="cursor-pointer" >
    <span><img src="../../../assets/images/logout-icn.svg" alt="logout-icn.svg"></span>
    <span class="gc-logout-text">Logout</span></a>
  </div>
